const StatusCodes = {
  UNAUTHORIZED_ERROR_CODE: 401,
  PAYMENT_REQUIRED: 402,
  SSO_INVALID_TOKEN_ERROR_CODE: 428,
  CONFLICT: 409,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
};

export default StatusCodes;
